/**
 * Универсальный скрипт для B2B форм с выбором страны
 * Работает с формами, которые имеют data-form-type="b2b" или data-form-type="directions-workwith"
 */
(function() {
  'use strict';

  // Инициализация формы
  function initB2BForm(formElement) {
    const formType = formElement.getAttribute('data-form-type') || 'b2b';
    const sectionId = formElement.getAttribute('data-section-id') || '';
    
    // Определяем префиксы классов в зависимости от типа формы
    const classPrefix = formType === 'directions-workwith' ? 'directions-workwith__' : 'b2b-';
    const formId = formElement.id;
    
    // Получаем элементы формы
    const submitBtn = document.getElementById(`${formType === 'directions-workwith' ? 'directions-workwith-submit' : 'b2b-submit'}-${sectionId}`);
    const buttonText = submitBtn ? submitBtn.querySelector(`.${classPrefix}button-text`) : null;
    const loading = document.getElementById(`${formType === 'directions-workwith' ? 'directions-workwith-loading' : 'b2b-loading'}-${sectionId}`);
    const message = document.getElementById(`${formType === 'directions-workwith' ? 'directions-workwith-message' : 'b2b-message'}-${sectionId}`);
    
    // Country selector elements
    const countrySelector = document.getElementById(`countrySelector-${sectionId}`);
    const countryTrigger = document.getElementById(`countryTrigger-${sectionId}`);
    const countryDropdown = document.getElementById(`countryDropdown-${sectionId}`);
    const countryFlag = document.getElementById(`countryFlag-${sectionId}`);
    const countryCodeDisplay = document.getElementById(`countryCodeDisplay-${sectionId}`);
    const countryCodeInput = document.getElementById(`countryCode-${sectionId}`);
    const countrySearch = document.getElementById(`countrySearch-${sectionId}`);
    const countryList = document.getElementById(`countryList-${sectionId}`);
    const phoneInput = document.getElementById(`phone-${sectionId}`);

    let countries = [];
    let selectedCountry = null;

    // Загружаем данные стран с сервера
    async function loadCountries() {
      try {
        const response = await fetch('https://office.ampriomilano.com/forms/country');
        if (response.ok) {
          const data = await response.json();
          countries = data.countries || [];
          const defaultCode = data.defaultCountry || 'AE';
          selectedCountry = countries.find(c => c.code === defaultCode) || countries[0];
        } else {
          // Fallback на дефолтную страну
          selectedCountry = { code: 'AE', name: 'United Arab Emirates', dialCode: '+971', format: '00-000-0000', placeholder: '00-000-0000', flag: '🇦🇪' };
          countries = [selectedCountry];
        }
      } catch (error) {
        // Fallback на дефолтную страну
        selectedCountry = { code: 'AE', name: 'United Arab Emirates', dialCode: '+971', format: '00-000-0000', placeholder: '00-000-0000', flag: '🇦🇪' };
        countries = [selectedCountry];
      }
      
      if (!selectedCountry || countries.length === 0) {
        return false;
      }
      return true;
    }

    // Функция форматирования номера телефона по формату страны
    function formatPhoneNumber(value, format) {
      let cleaned = value.replace(/[^\d]/g, '');
      if (!format || cleaned.length === 0) return cleaned;
      
      let formatted = '';
      let digitIndex = 0;
      for (let i = 0; i < format.length && digitIndex < cleaned.length; i++) {
        if (format[i] === '0') {
          formatted += cleaned[digitIndex];
          digitIndex++;
        } else {
          formatted += format[i];
        }
      }
      return formatted;
    }

    // Заполнение списка стран в dropdown
    function populateCountryList(filter = '') {
      if (!countryList) return;
      
      countryList.innerHTML = '';
      const filtered = countries.filter(country => 
        country.name.toLowerCase().includes(filter.toLowerCase()) ||
        country.dialCode.includes(filter) ||
        country.code.toLowerCase().includes(filter.toLowerCase())
      );

      filtered.forEach(country => {
        const item = document.createElement('div');
        item.className = `${classPrefix}country-item ${selectedCountry.code === country.code ? 'selected' : ''}`;
        item.innerHTML = `
          <span class="${classPrefix}country-item-flag">${country.flag}</span>
          <span class="${classPrefix}country-item-name">${country.name}</span>
          <span class="${classPrefix}country-item-code">${country.dialCode}</span>
        `;
        item.addEventListener('click', () => selectCountry(country));
        countryList.appendChild(item);
      });
    }

    // Выбор страны
    function selectCountry(country) {
      selectedCountry = country;
      if (countryCodeInput) countryCodeInput.value = country.code;
      if (countryFlag) countryFlag.textContent = country.flag;
      if (countryCodeDisplay) {
        countryCodeDisplay.textContent = country.dialCode;
        // Обновляем padding для поля ввода в зависимости от длины кода
        const prefixWidth = country.dialCode.length * 8 + 4;
        if (phoneInput) {
          phoneInput.style.paddingLeft = (prefixWidth + 18) + 'px';
        }
      }
      if (phoneInput) phoneInput.placeholder = country.placeholder || country.format || '00-00 00';
      closeCountryDropdown();
      
      // Форматируем текущий номер если он есть
      if (phoneInput && phoneInput.value) {
        const cleaned = phoneInput.value.replace(/[^\d]/g, '');
        phoneInput.value = formatPhoneNumber(cleaned, country.format);
      }
    }

    // Открытие/закрытие dropdown
    function toggleCountryDropdown() {
      if (countryDropdown && countryDropdown.style.display === 'none') {
        openCountryDropdown();
      } else {
        closeCountryDropdown();
      }
    }

    function openCountryDropdown() {
      if (!countryDropdown) return;
      countryDropdown.style.display = 'flex';
      populateCountryList();
      setTimeout(() => {
        if (countrySearch) countrySearch.focus();
      }, 50);
    }

    function closeCountryDropdown() {
      if (!countryDropdown) return;
      countryDropdown.style.display = 'none';
      if (countrySearch) countrySearch.value = '';
    }

    // Автоматическое определение страны по IP
    async function detectCountryByIP() {
      try {
        const response = await fetch('https://ipapi.co/json/', {
          method: 'GET',
          headers: { 'Accept': 'application/json' }
        });
        
        if (response.ok) {
          const data = await response.json();
          const countryCode = data.country_code;
          
          if (countryCode) {
            // Ищем страну в списке (регистронезависимо)
            const country = countries.find(c => c.code.toUpperCase() === countryCode.toUpperCase());
            if (country) {
              selectCountry(country);
              return;
            }
          }
        }
      } catch (error) {
        // Country detection failed silently
      }
    }

    // Инициализация country selector
    async function initCountrySelector() {
      const loaded = await loadCountries();
      if (!loaded) {
        return false;
      }

      if (countrySelector && phoneInput) {
        // Устанавливаем начальный padding для префикса и placeholder
        if (countryCodeDisplay && selectedCountry) {
          const initialWidth = selectedCountry.dialCode.length * 8 + 4;
          phoneInput.style.paddingLeft = (initialWidth + 18) + 'px';
          if (selectedCountry.placeholder || selectedCountry.format) {
            phoneInput.placeholder = selectedCountry.placeholder || selectedCountry.format;
          }
        }
        
        selectCountry(selectedCountry);
        
        // Обработчики событий
        if (countryTrigger) {
          countryTrigger.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleCountryDropdown();
          });
        }

        if (countrySearch) {
          countrySearch.addEventListener('input', (e) => {
            populateCountryList(e.target.value);
          });
        }

        // Форматирование номера телефона при вводе
        phoneInput.addEventListener('input', (e) => {
          const value = e.target.value;
          const formatted = formatPhoneNumber(value, selectedCountry.format);
          if (formatted !== value) {
            e.target.value = formatted;
          }
        });

        // Закрытие dropdown при клике вне его
        document.addEventListener('click', (e) => {
          if (countrySelector && !countrySelector.contains(e.target)) {
            closeCountryDropdown();
          }
        });

        // Попытка автоматического определения страны
        detectCountryByIP();
      }
      
      return true;
    }

    // Обработка отправки формы
    function handleFormSubmit(e) {
      e.preventDefault();
      e.stopPropagation();

      // Show loading state
      if (submitBtn) submitBtn.disabled = true;
      if (buttonText) buttonText.style.display = 'none';
      if (loading) loading.style.display = 'flex';
      if (message) message.style.display = 'none';

      // Get form data
      const formData = new FormData(formElement);
      const phone = formData.get('phone');
      if (!phone) {
        showMessage('Please enter your phone number', 'error');
        resetSubmitButton();
        return;
      }
      
      const phoneCleaned = phone.replace(/[\s\-\(\)]/g, '');
      const email = formData.get('email');
      if (!email) {
        showMessage('Please enter your email', 'error');
        resetSubmitButton();
        return;
      }
      const emailTrimmed = email.toLowerCase().trim();
      
      // Validate country code
      if (!countryCodeInput || !countryCodeInput.value) {
        showMessage('Please select your country', 'error');
        resetSubmitButton();
        return;
      }
      
      // Validate phone number
      const phoneRegex = /^[0-9]{6,}$/;
      if (!phoneRegex.test(phoneCleaned)) {
        showMessage('Please enter a valid phone number (minimum 6 digits)', 'error');
        resetSubmitButton();
        return;
      }
      
      // Validate email
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(emailTrimmed)) {
        showMessage('Please enter a valid email address', 'error');
        resetSubmitButton();
        return;
      }
      
      const countryCode = countryCodeInput.value;
      const dialCode = selectedCountry ? selectedCountry.dialCode : '';

      const data = {
        firstName: formData.get('firstName') || '',
        lastName: formData.get('lastName') || '',
        businessName: formData.get('businessName') || '',
        position: formData.get('position') || '',
        businessType: formData.get('businessType') || '',
        seatingCapacity: formData.get('seatingCapacity') || '',
        countryCode: countryCode,
        dialCode: dialCode,
        phone: phoneCleaned,
        email: emailTrimmed
      };

      // Send to API
      fetch('https://office.ampriomilano.com/forms/b2b-submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      })
      .then(async response => {
        const contentType = response.headers.get('content-type');
        let result;
        
        if (contentType && contentType.includes('application/json')) {
          try {
            result = await response.json();
          } catch (parseError) {
            const text = await response.text();
            throw new Error(`Failed to parse JSON response: ${text.substring(0, 100)}`);
          }
        } else {
          const text = await response.text();
          throw new Error(`Server returned non-JSON response (${response.status}): ${text.substring(0, 100)}`);
        }
        
        if (!response.ok) {
          throw new Error(result?.error || result?.message || `HTTP error! status: ${response.status}`);
        }
        
        return result;
      })
      .then(result => {
        // Проверяем разные варианты успешного ответа
        if (result.success === true || result.success === 'true' || result.status === 'success' || (result.message && !result.error)) {
          showMessage('Thank you! Your B2B partnership request has been submitted successfully. We will contact you soon.', 'success');
          formElement.reset();
          // Reset country selector
          if (selectedCountry) {
            selectCountry(selectedCountry);
          }
        } else {
          throw new Error(result.error || result.message || 'Failed to submit form');
        }
      })
      .catch(error => {
        showMessage('Sorry, there was an error submitting your request. Please try again.', 'error');
      })
      .finally(() => {
        resetSubmitButton();
      });
    }

    function resetSubmitButton() {
      if (submitBtn) submitBtn.disabled = false;
      if (buttonText) buttonText.style.display = 'block';
      if (loading) loading.style.display = 'none';
    }

    function showMessage(text, type) {
      if (!message) return;
      message.textContent = text;
      message.className = `${classPrefix}message ${type}`;
      message.style.display = 'block';

      // Auto-hide after 5 seconds
      setTimeout(() => {
        message.style.display = 'none';
      }, 5000);
    }

    // Инициализация
    initCountrySelector().then(() => {
      // Подключаем обработчик отправки формы только после инициализации
      formElement.addEventListener('submit', handleFormSubmit);
    }).catch(() => {
      // Подключаем обработчик даже при ошибке, чтобы форма могла работать
      formElement.addEventListener('submit', handleFormSubmit);
    });
  }

  // Инициализация всех форм при загрузке DOM
  document.addEventListener('DOMContentLoaded', function() {
    // Ищем все формы с data-form-type
    const b2bForms = document.querySelectorAll('[data-form-type="b2b"], [data-form-type="directions-workwith"]');
    b2bForms.forEach(form => {
      initB2BForm(form);
    });
  });
})();